(function () {
  function letterRange(letter) {
    if (!letter || letter < 'A' || letter > 'Z') return 'a-f';
    var code = letter.charCodeAt(0);
    if (code <= 70) return 'a-f';
    if (code <= 76) return 'g-l';
    if (code <= 82) return 'm-r';
    return 's-z';
  }

  function initSection(section) {
    var root = section.querySelector('[data-tcb-brands-root]');
    if (!root) return;

    var perPage = parseInt(section.getAttribute('data-per-page') || '24', 10);
    var grid = root.querySelector('[data-tcb-brands-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-tcb-brand-card]'));
    var countEl = root.querySelector('[data-tcb-brands-count]');
    var emptyEl = root.querySelector('[data-tcb-brands-empty]');
    var loadWrap = section.querySelector('[data-tcb-load-more-wrap]');
    var loadBtn = section.querySelector('[data-tcb-load-more]');
    var sortSelect = root.querySelector('[data-tcb-brands-sort]');
    var letterBtns = root.querySelectorAll('[data-tcb-letter-filter]');
    var scrollGrid = section.querySelector('[data-tcb-scroll-grid]');

    var state = {
      letter: 'all',
      sort: 'az',
      page: 1
    };

    cards.forEach(function (card) {
      var letter = (card.getAttribute('data-letter') || '').toUpperCase();
      card.setAttribute('data-range', letterRange(letter));
    });

    function sortCards() {
      var sorted = cards.slice().sort(function (a, b) {
        var fa = a.getAttribute('data-featured') === 'true';
        var fb = b.getAttribute('data-featured') === 'true';
        var na = (a.getAttribute('data-name') || '').toLowerCase();
        var nb = (b.getAttribute('data-name') || '').toLowerCase();

        if (state.sort === 'featured') {
          if (fa !== fb) return fa ? -1 : 1;
          return na.localeCompare(nb);
        }
        if (state.sort === 'za') return nb.localeCompare(na);
        return na.localeCompare(nb);
      });

      sorted.forEach(function (card) {
        grid.appendChild(card);
      });
    }

    function filteredCards() {
      return cards.filter(function (card) {
        if (state.letter === 'all') return true;
        return card.getAttribute('data-range') === state.letter;
      });
    }

    function updateView() {
      var visibleSet = filteredCards();
      var total = visibleSet.length;
      var showCount = Math.min(state.page * perPage, total);
      var shown = 0;

      cards.forEach(function (card) {
        card.hidden = true;
        card.classList.remove('is-visible');
      });

      visibleSet.forEach(function (card, index) {
        if (index < showCount) {
          card.hidden = false;
          card.classList.add('is-visible');
          shown += 1;
        }
      });

      if (countEl) {
        if (total === 0) {
          countEl.textContent = 'No brands found';
        } else if (total <= perPage) {
          countEl.textContent = 'Showing all ' + total + ' brands';
        } else {
          countEl.textContent = 'Showing 1–' + shown + ' of ' + total + ' brands';
        }
      }

      if (emptyEl) emptyEl.hidden = total > 0;
      if (loadWrap) loadWrap.hidden = shown >= total;
    }

    letterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.letter = btn.getAttribute('data-tcb-letter-filter');
        state.page = 1;
        letterBtns.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        updateView();
      });
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        state.sort = sortSelect.value;
        sortCards();
        updateView();
      });
    }

    if (loadBtn) {
      loadBtn.addEventListener('click', function () {
        state.page += 1;
        updateView();
      });
    }

    if (scrollGrid) {
      scrollGrid.addEventListener('click', function (e) {
        e.preventDefault();
        var target = section.querySelector('#tcb-brands-grid');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    sortCards();
    updateView();
  }

  function boot() {
    document.querySelectorAll('[data-tcb-brands-page]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-tcb-brands-page]')) {
      initSection(event.target.querySelector('[data-tcb-brands-page]'));
    }
  });
})();
